import { useMutation } from "react-query";
import useTokenStore from "store/tokenStore";
import InitApi from "api/InitApi";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";

const usePublishConfigurations = () => {
	const { accessToken } = useTokenStore();

	const save = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post("/publish-configurations");
		return res.data;
	};

	return useMutation(save, {
		onSuccess: async (data) => {
			toast.success(data?.message);
		},
		onError: async (error) => {
			const errorMessage =
				error?.response?.data?.message || "Error publishing configurations";
			toast.error(<ServerErrors errorMessage={errorMessage} />, {
				duration: 5000,
			});
		},
	});
};

export default usePublishConfigurations;
